import React, { Component } from "react";

import { getLangData } from "../services/lang";
import img404 from "../img/404.png";

class PageNotFound extends Component {

    render() {

        const langData = getLangData();

        return (
            <div className="container text-center">
                <p className="h1 fw-300">{langData.meta.pageNotFound}</p>
                <img src={img404} alt="page not found" />
            </div>
        );
    }
}

export default PageNotFound;